// src/pages/Appli/AppliAdmin/clubs-admin/components/ClubsCardsMobile.jsx

import React, { useState } from "react";

import {
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

import {
  AdherentCountEditor,
  ClubActionButtons,
  ClubLogo,
  ContactBlock,
  DepartmentBadge,
  MembersButton,
} from "./ClubCells";

export default function ClubsCardsMobile({
  rows,
  loading,

  deletingId,

  memberCountsByClub,
  memberCountsLoadingByClub,

  adherentCountsSavingByClub,
  onSaveAdherentCount,

  onMembers,
  onEdit,
  onDelete,
}) {
  const [
    expandedIds,
    setExpandedIds,
  ] = useState([]);

  const toggleExpanded = (
    clubId,
  ) => {
    setExpandedIds(
      (previousIds) =>
        previousIds.includes(
          clubId,
        )
          ? previousIds.filter(
              (currentId) =>
                currentId !==
                clubId,
            )
          : [
              ...previousIds,
              clubId,
            ],
    );
  };

  if (loading) {
    return (
      <div className="rounded-3xl border border-slate-200 bg-white px-4 py-10 text-center text-slate-500 shadow-sm dark:border-slate-800 dark:bg-slate-900 lg:hidden">
        Chargement des clubs…
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <div className="rounded-3xl border border-slate-200 bg-white px-4 py-10 text-center text-slate-500 shadow-sm dark:border-slate-800 dark:bg-slate-900 lg:hidden">
        Aucun club ne correspond aux filtres.
      </div>
    );
  }

  return (
    <div className="space-y-3 lg:hidden">
      {rows.map((club) => {
        const expanded =
          expandedIds.includes(
            club.id,
          );

        return (
          <article
            key={club.id}
            className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900"
          >
            <div className="flex items-start gap-3">
              <ClubLogo
                src={club.logo_url}
                alt={club.nom_club}
              />

              <div className="min-w-0 flex-1">
                <h2 className="text-[15px] font-semibold leading-5 text-slate-900 dark:text-white">
                  {club.nom_club ||
                    "Club sans nom"}
                </h2>

                <div className="mt-1 flex flex-wrap items-center gap-2">
                  <DepartmentBadge>
                    {club.departement_club ||
                      "?"}
                  </DepartmentBadge>

                  {club.numero_club ? (
                    <span className="text-[11px] text-slate-500 dark:text-slate-400">
                      N° {club.numero_club}
                    </span>
                  ) : null}
                </div>

                {club.email_club ? (
                  <p className="mt-2 truncate text-[12px] text-slate-600 dark:text-slate-300">
                    {club.email_club}
                  </p>
                ) : null}
              </div>
            </div>

            <AdherentCountEditor
              club={club}
              saving={Boolean(
                adherentCountsSavingByClub[
                  club.id
                ],
              )}
              onSave={onSaveAdherentCount}
              className="mt-4"
            />

            <div className="mt-3 grid grid-cols-2 gap-2">
              <MembersButton
                club={club}
                count={
                  memberCountsByClub[
                    club.id
                  ]
                }
                loading={Boolean(
                  memberCountsLoadingByClub[
                    club.id
                  ],
                )}
                onMembers={onMembers}
                className="w-full"
              />

              <button
                type="button"
                onClick={() =>
                  toggleExpanded(
                    club.id,
                  )
                }
                className="inline-flex h-10 items-center justify-center gap-2 rounded-2xl border border-slate-300 bg-white px-3 text-sm font-medium text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
              >
                {expanded ? (
                  <FaChevronUp />
                ) : (
                  <FaChevronDown />
                )}

                {expanded
                  ? "Réduire"
                  : "Détails"}
              </button>
            </div>

            {expanded ? (
              <div className="mt-4 border-t border-slate-200 pt-4 dark:border-slate-800">
                <div className="grid gap-4 sm:grid-cols-2">
                  <div>
                    <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400">
                      Adresse
                    </p>

                    <p className="mt-2 whitespace-pre-line text-sm leading-6 text-slate-700 dark:text-slate-200">
                      {club.adresse_club ||
                        "Adresse non renseignée"}
                    </p>
                  </div>

                  <div>
                    <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400">
                      Contacts
                    </p>

                    <div className="mt-2">
                      <ContactBlock
                        club={club}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <ClubActionButtons
                    club={club}
                    memberCount={
                      memberCountsByClub[
                        club.id
                      ]
                    }
                    memberCountLoading={Boolean(
                      memberCountsLoadingByClub[
                        club.id
                      ],
                    )}
                    onMembers={onMembers}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    deletingId={deletingId}
                    showMembers={false}
                  />
                </div>
              </div>
            ) : null}
          </article>
        );
      })}
    </div>
  );
}